var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, ginni } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EMPTY_SECTION } from './types';
import { groupBy, keyBy } from 'lodash';
import { OptionMenuItem } from './option-menu-item';
import { animated } from '@react-spring/web';
import { useInfiniteScrollArray } from '../hooks/use-infinite-scroll-array';
import { OptionMenuLoadingMessage } from './option-menu-loading-message';
import { useLang } from '../hooks/use-lang';
var cls = classNames('popup-menu');
export var OptionMenuDefaultProps = {
  showHead: true,
  showFoot: true,
  headProps: {
    horizontalPadding: 12,
    verticalPadding: 8,
    comfortPadding: 4
  },
  infiniteScrollConfig: {
    rootMargin: '0px 0px 100px 0px',
    itemsPerPage: 0
  },
  noMatchesText: 'No matches found',
  showSectionTitles: true,
  colors: {
    text: 'strong',
    background: 'canvas',
    border: 'just-visible',
    hover: {
      background: 'subtle-canvas'
    },
    active: {
      background: 'subtle-chrome'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    font-size: ", ";\n    border-radius: 2px 2px ", " ", ";\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    align-items: stretch;\n    overflow: hidden;\n\n    ", "\n  "], ["\n    ", ";\n    font-size: ", ";\n    border-radius: 2px 2px ", " ", ";\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    align-items: stretch;\n    overflow: hidden;\n\n    ", "\n  "])), theme.APPLY_COLORS, theme.FONT_SIZE(14), theme.UNIT(2), theme.UNIT(2), function (_a) {
    var width = _a.width;
    return width && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), width);
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    flex-grow: 1;\n  "], ["\n    margin: 0;\n    padding: 0;\n    flex-grow: 1;\n  "])))
});
var HeadStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "    \n  "], ["\n    ", "    \n  "])), function (_a) {
    var _b = _a.horizontalPadding,
      horizontalPadding = _b === void 0 ? 12 : _b,
      _c = _a.verticalPadding,
      verticalPadding = _c === void 0 ? 8 : _c,
      _d = _a.comfortPadding,
      comfortPadding = _d === void 0 ? 4 : _d;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      padding-bottom: ", "px;\n    "], ["\n      padding: ", "px ", "px;\n      padding-bottom: ", "px;\n    "])), verticalPadding, horizontalPadding, verticalPadding + comfortPadding);
  })
});
var FootStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "    \n  "], ["\n    ", "    \n  "])), function (_a) {
    var _b = _a.horizontalPadding,
      horizontalPadding = _b === void 0 ? 12 : _b,
      _c = _a.verticalPadding,
      verticalPadding = _c === void 0 ? 8 : _c,
      _d = _a.comfortPadding,
      comfortPadding = _d === void 0 ? 4 : _d;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      padding-bottom: ", "px;\n    "], ["\n      padding: ", "px ", "px;\n      padding-bottom: ", "px;\n    "])), verticalPadding, horizontalPadding, verticalPadding + comfortPadding);
  })
});
var SectionStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    box-sizing: border-box;\n  "], ["\n    border-top: 1px solid ", ";\n    box-sizing: border-box;\n  "])), theme.COLOR('just-visible'))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n  "], ["\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: ", " ", ";\n    box-sizing: border-box;\n  "], ["\n    padding: ", " ", ";\n    box-sizing: border-box;\n  "])), theme.UNIT(2), theme.UNIT(3))
});
var SectionNameStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", "em;\n    font-weight: 600;\n    margin: 0;\n    padding: ", " ", ";\n    text-transform: uppercase;\n    color: ", ";\n  "], ["\n    font-size: ", "em;\n    font-weight: 600;\n    margin: 0;\n    padding: ", " ", ";\n    text-transform: uppercase;\n    color: ", ";\n  "])), 11 / 14, theme.UNIT(2), theme.UNIT(3), theme.COLOR('subtle'))
});
var SentryStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ScrollStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    overflow-y: auto;\n\n    ", "\n  "], ["\n    overflow-y: auto;\n\n    ", "\n  "])), function (_a) {
    var maxHeight = _a.maxHeight;
    return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      max-height: ", ";\n    "], ["\n      max-height: ", ";\n    "])), maxHeight);
  })
});
var LoadingMessageStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var NoMatchesStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    color: ", ";\n    padding: ", " ", ";\n  "], ["\n    color: ", ";\n    padding: ", " ", ";\n  "])), theme.COLOR('subtle'), theme.UNIT(2), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenu',
  Container: styled(animated.div)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled.header(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  Body: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Scroll: styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ScrollStyles),
  NoMatches: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), NoMatchesStyles),
  Section: styled.section(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  SectionName: styled.h6(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), SectionNameStyles),
  Items: styled.ul(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled(OptionMenuItem)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Sentry: styled.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), SentryStyles),
  LoadingMessage: styled(OptionMenuLoadingMessage)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), LoadingMessageStyles),
  Foot: styled.footer(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), FootStyles)
};
export var OptionMenu = React.forwardRef(function (props, ref) {
  var componentProps = useComponentProps(My.NAME, OptionMenuDefaultProps, props);
  var className = componentProps.className,
    style = componentProps.style,
    children = componentProps.children,
    menu = componentProps.menu,
    colors = componentProps.colors,
    activeItem = componentProps.activeItem,
    showHead = componentProps.showHead,
    showFoot = componentProps.showFoot,
    headProps = componentProps.headProps,
    footProps = componentProps.footProps,
    itemVerticalPadding = componentProps.itemVerticalPadding,
    itemHorizontalPadding = componentProps.itemHorizontalPadding,
    onItemMouseOver = componentProps.onItemMouseOver,
    onItemSelect = componentProps.onItemSelect,
    highlightText = componentProps.highlightText,
    highlightTextClassName = componentProps.highlightTextClassName,
    onMouseEnter = componentProps.onMouseEnter,
    onMouseLeave = componentProps.onMouseLeave,
    onMouseOver = componentProps.onMouseOver,
    itemComponent = componentProps.itemComponent,
    itemsComponent = componentProps.itemsComponent,
    itemsPerPage = componentProps.itemsPerPage,
    _a = componentProps.itemsProps,
    itemsProps = _a === void 0 ? {} : _a,
    itemProps = componentProps.itemProps,
    _b = componentProps.infiniteScrollConfig,
    infiniteScrollConfig = _b === void 0 ? {} : _b,
    selectedItems = componentProps.selectedItems,
    selectedItem = componentProps.selectedItem,
    loadingMoreText = componentProps.loadingMoreText,
    noMatchesText = componentProps.noMatchesText;
  var _c = menu.sections,
    sections = _c === void 0 ? [EMPTY_SECTION] : _c,
    items = menu.items;
  var selections = selectedItem && [selectedItem] || selectedItems || [];
  var t = useLang();
  var head = menu.head || componentProps.head;
  var foot = menu.foot || componentProps.foot;
  ginni.verbose.group('OptionMenu');
  ginni.verbose.log('items', items);
  ginni.verbose.log('activeItem', activeItem);
  ginni.verbose.log('option menu selections', selections);
  // if (!items.length) {
  //   return null;
  // };
  var defaultInfiniteScroll = useInfiniteScrollArray(__assign({
    all: menu.items
  }, infiniteScrollConfig));
  // get the true infinite scroll. This allows us to implement a different one externally, and feed it in.
  var infiniteScroll = componentProps.infiniteScroll || defaultInfiniteScroll;
  var sentryRef = infiniteScroll.sentryRef,
    rootRef = infiniteScroll.rootRef,
    hasNextPage = infiniteScroll.hasNextPage,
    loading = infiniteScroll.loading;
  var isLoading = props.isLoading || loading;
  // if we're using custom infinite scroll, we need to use the items from the menu not the infinite scroll scroll
  var finalItems = componentProps.infiniteScroll ? menu.items : defaultInfiniteScroll.items;
  var sectionsById = componentProps.sectionsById || keyBy(sections, 'id');
  var itemsBySection = componentProps.itemsBySection || groupBy(finalItems, function (item) {
    return (item === null || item === void 0 ? void 0 : item.section) || '';
  });
  var activeItemRef = useRef(null);
  // Scroll to the active when it changes
  React.useEffect(function () {
    var _a;
    if (activeItemRef) {
      (_a = activeItemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth',
        // Optional, makes the scrolling smooth
        block: 'nearest' // Scrolls only if the item is not fully visible
      });
    }
  }, [activeItem === null || activeItem === void 0 ? void 0 : activeItem.id]);
  ginni.verbose.log('sectionsById', sectionsById);
  ginni.verbose.log('itemsBySection', itemsBySection);
  ginni.verbose.groupEnd();
  var Items = menu.itemsComponent || itemsComponent || My.Items;
  var itemIndex = 0;
  var handleClick = function (item, index) {
    return function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (onItemSelect) {
        onItemSelect({
          item: item,
          event: event
        });
      }
    };
  };
  var noMatches = !finalItems.length && !isLoading;
  var showBody = !!finalItems.length || noMatches || hasNextPage;
  return React.createElement(My.Container, {
    tabIndex: -1,
    width: menu.width,
    // ref={ref}
    style: style,
    colors: colors,
    className: cls.name(className),
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter,
    onMouseOver: onMouseOver
  }, showHead && !!head && React.createElement(My.Head, __assign({}, headProps), head), showBody && React.createElement(My.Body, {
    tabIndex: -1,
    ref: rootRef
  }, React.createElement(My.Scroll, {
    ref: ref,
    maxHeight: itemsProps.maxHeight ? "".concat(itemsProps.maxHeight, "px") : 'none'
  }, sections.map(function (section, i) {
    var sectionDefn = sectionsById[section.id];
    if (!sectionDefn) {
      return null;
    }
    var sectionItems = itemsBySection[section.id] || [];
    if (!sectionItems.length) {
      return null;
    }
    ;
    return React.createElement(My.Section, {
      tabIndex: -1,
      key: section.id || "section-".concat(i)
    }, section.name && React.createElement(My.SectionName, {
      horizontalPadding: itemHorizontalPadding
    }, section.name), React.createElement(Items, __assign({
      style: {
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        listStyle: 'none'
      }
    }, itemsProps, {
      tabIndex: -1
    }), sectionItems.map(function (item, j) {
      var isActive = activeItem && activeItem.id === item.id && activeItem.section === item.section;
      var isSelected = selections.some(function (selection) {
        return selection.id === item.id;
      });
      // const Item = item.component || itemComponent || My.Item;
      var result = React.createElement(My.Item, __assign({
        ref: isActive ? activeItemRef : null,
        component: itemComponent,
        isDisabled: item.isDisabled,
        isSelected: isSelected,
        verticalPadding: itemVerticalPadding,
        horizontalPadding: itemHorizontalPadding,
        highlightTextClassName: highlightTextClassName,
        highlightText: highlightText,
        index: itemIndex,
        onClick: handleClick(item, itemIndex),
        onMouseOver: onItemMouseOver,
        isActive: isActive,
        item: item,
        key: itemIndex
      }, itemProps));
      itemIndex++;
      return result;
    })));
  }), noMatches && React.createElement(My.NoMatches, null, t(noMatchesText)), hasNextPage && React.createElement(My.Sentry, {
    ref: sentryRef
  }), hasNextPage && React.createElement(My.LoadingMessage, {
    text: loadingMoreText
  }))), showFoot && !!foot && React.createElement(My.Foot, __assign({}, footProps), foot));
});
/* @ts-ignore */
OptionMenu.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;